import { render } from "./AreaField.vue?vue&type=template&id=7190632f"
import script from "./AreaField.vue?vue&type=script&lang=ts"
export * from "./AreaField.vue?vue&type=script&lang=ts"
script.render = render

export default script